import { createContext } from "react";
import type { AuthMode, AuthUser } from "@/lib/auth";

export interface AuthContextValue {
  user: AuthUser | null;
  isAuthenticated: boolean;
  /**
   * True until the API's auth mode has been confirmed on first load. The guard
   * shows a spinner while this is true rather than guessing the auth state.
   */
  isLoading: boolean;
  /** The authoritative auth mode (from the API, falling back to the build hint). */
  mode: AuthMode;
  login: (returnPath?: string) => void;
  logout: () => void;
  /** Re-read the session (e.g. after the callback page stores a token). */
  refresh: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
